<script>
import { PolarArea } from 'vue-chartjs'
import { chartData, chartOptions } from '@/config/charts'

export default {
  extends: PolarArea,
  name: 'VotingResultsPolarDiagram',
  props: {
    results: {
      type: Array,
      default: [],
    }
  },
  beforeDestroy() {
    this.chartData.labels = []
    this.chartData.datasets[0].data = []
  },
  data() {
    return {
      chartData: chartData
    }
  },
  mounted() {
    this.getChart()
  },
  watch: {
    results: {
      handler() {
        this.getChart()
      },
      deep: true
    }
  },
  methods: {
    getChart() {
      this.chartData.labels = []
      this.chartData.datasets[0].data = []
      for (const result of this.results) {
        this.chartData.labels.push(result.title.slice(0, 57))
        this.chartData.datasets[0].data.push(result.count)
      }
      const options = {
        ...chartOptions,
        scale: {
          ticks: {
            display: false
          }
        }
      }
      this.renderChart({
        labels: this.chartData.labels,
        datasets: this.chartData.datasets,
      }, options)
    }
  }
}
</script>

<style scoped>

</style>
